// John Eldhose 20180613
import { RestfulPost } from './Restful';

export async function updateProfile(data) {
  const prof = await RestfulPost('updateProfile', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return prof;
}



// WEBPACK FOOTER //
// ./src/Api/updateProfile.js